<template lang="pug">
#skeleton-bloco-resumo-analise-eligibilidade
    el-skeleton(:loading='carregando', animated)
        template(slot='template')
            .skeleton-bloco-interno
                el-skeleton-item.dado-icone(variant='rect')

        template
            slot
</template>

<script>
export default {
    name: 'SkeletonBlocoResumoAnaliseEligibilidade',
    props: {
        carregando: {
            type: Boolean,
            default: () => false
        }
    }
};
</script>

<style lang="scss" scoped>
#skeleton-bloco-resumo-analise-eligibilidade {
    .skeleton-bloco-interno {
        min-width: 85px;
        border-radius: 10px;
        display: flex;
        align-items: center;
    }
}
</style>
